const config = {
  // baseUrl: 'http://localhost:5000',
  baseUrl: 'https://appbk.jamamasjidquba.com', // Replace this with your actual IP address
};

export default config;